module.exports = __webpack_public_path__ + "img/shenhezhong.54179a62.png";